import request from "../utils/request";

export const get = () => request.get("/api/calendar");
export const update = (data) => request.post("/api/calendar", data);
